// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__EEajG","current":"style_current__2Yelm","arrow":"style_arrow__2uaE9"};